// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jOe7","fullView":"styles_fullView__1Cqj9"};